import * as React from 'react'
import { CloudHubMuleSvg } from './ConnectorsImages/CloudHubMuleSvg'
import { ServiceNowSvg } from './ConnectorsImages/ServiceNowSvg'
import { SalesforceServiceCloudSvg } from './ConnectorsImages/SalesforceServiceCloudSvg'
import { JIRASvg } from './ConnectorsImages/JIRASvg'
import { ZendeskSvg } from './ConnectorsImages/ZendeskSvg'
import { SlackSvg } from './ConnectorsImages/SlackSvg'
import ConnectorImage from './ConnectorsImages/connector-icon.png'
import APIImage from './ConnectorsImages/API-icon.png'
import './ToolsPage.css'
import { AnypointCustomMetricsConnectorSvg } from './ConnectorsImages/AnypointCustomMetricsConnectorSvg'

export interface IExternalProps {
  title: string
  description: string
  link: string
  type: string
}

export type ValueProps = IExternalProps

export type Props = ValueProps

export interface IState {
  isHovering: boolean
}

export default class ToolsConnector extends React.PureComponent<Props, IState> {
  
  constructor(props: Props) {
    super(props)
    
    this.state = {isHovering: false}
    this.onHover = this.onHover.bind(this)
  }
  
  onHover(flag: boolean) {
    return () => this.setState({isHovering: flag})
  }
  
  static getImage(title: string) {
    switch (title) {
      case 'CloudHub - Mule 3':
        return <CloudHubMuleSvg/>
      case 'CloudHub - Mule 4':
        return <CloudHubMuleSvg/>
      case 'Log Tokenization - Mule 3':
        return <img src={ConnectorImage}/>
      case 'Log Tokenization - Mule 4':
        return <img src={APIImage}/>
      case 'Service Now':
        return <ServiceNowSvg/>
      case 'Salesforce Service Cloud':
        return <SalesforceServiceCloudSvg/>
      case 'JIRA':
        return <JIRASvg/>
      case 'Zendesk':
        return <ZendeskSvg/>
      case 'Slack':
        return <SlackSvg/>
      case 'Custom Metrics Connector - Mule 4':
        return <AnypointCustomMetricsConnectorSvg/>
      
      default:
        return <img src={ConnectorImage}/>
    }
  }

  static getTitleForId(title: string) {
    const lowTitle = title.toLowerCase()
    const hyphenTitle = lowTitle.replace(/ - /gi, '-')
    return hyphenTitle.replace(/ /gi, '-')
  }
  
  render() {
    const {isHovering} = this.state
    const {title, description, link, type} = this.props
    const titleForId = ToolsConnector.getTitleForId(title)
    
    return (
      <div className={'tools-connector-container'} data-test-id={`tools-connector-container-${titleForId}`}>
        <a href={link} target={'_blank'}>
          <div
            className={'tools-connector'}
            data-test-id={`tools-connector-${titleForId}`}
            onMouseEnter={this.onHover(true)}
            onMouseLeave={this.onHover(false)}
          >
            {
              isHovering ? this.renderHoveredStatus(title, description) : this.renderInitialStatus(title, type)
            }
          </div>
        </a>
      </div>
    )
  }
  
  renderInitialStatus(title: string, type: string) {
    const titleForId = ToolsConnector.getTitleForId(title)

    return (
      <div className={'connector-container'} data-test-id={`connector-container-${titleForId}`}>
        <div className={'connector-header'} data-test-id={`connector-header-${titleForId}`}>
          <img className={'connector-icon'} src={ConnectorImage} data-test-id={`connector-icon-${titleForId}`}/>
          <span className={'connector-header-info'} data-test-id={`connector-header-info-${titleForId}`}>Connector</span>
        </div>
        <div className={'connector-content'} data-test-id={`connector-content-${titleForId}`}>
          <div className={'connector-main-info'} data-test-id={`connector-main-info-${titleForId}`}>
            <div className={`connector-image-container ${type}`} data-test-id={`connector-image-container-${titleForId}`}>
              {ToolsConnector.getImage(title)}
            </div>
            <span className={'connector-title'} data-test-id={`connector-title-${titleForId}`}>{title}</span>
          </div>
          
          <div className={'connector-view-info'} data-test-id={`connector-view-info-${titleForId}`}>
            <span>View in Exchange</span>
          </div>
        </div>
      </div>
    )
  }
  
  renderHoveredStatus(title: string, description: string) {
    const titleForId = ToolsConnector.getTitleForId(title)

    return (
      <div className={'connector-container-hover'} data-test-id={`connector-container-hover-${titleForId}`}>
        <div className={'connector-description'} data-test-id={`connector-description-${titleForId}`}>{description}</div>
        <div className={'connector-view-info-hover'} data-test-id={`connector-view-info-hover-${titleForId}`}>
          <span>View in Exchange</span>
        </div>
      </div>
    )
  }
}
